import styled from 'styled-components';
import { CONTRAST, QUARTER_CONTRAST } from '../theme';

export const Input = styled.input`
  background-color: transparent;
  color: ${CONTRAST};
  border-radius: 3px;
  padding: 12px;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid ${QUARTER_CONTRAST};
  cursor: pointer;
`;
